const CarsCardSkeleton = () => {
  return (
    <div className="relative flex min-h-[470px] flex-col rounded-3xl bg-white px-1">
      {/* Image placeholder */}
      <div className="mt-1 h-60 w-full animate-pulse !rounded-3xl bg-gray-200" />

      <div className="flex flex-1 flex-col p-4">
        {/* Header section */}
        <div className="mb-auto mt-1 flex items-center justify-between">
          <div className="h-4 w-36 animate-pulse !rounded-md bg-gray-200" />
          <div className="h-4 w-16 animate-pulse !rounded-md bg-gray-200" />
        </div>

        {/* Middle section with pricing */}
        <div className="inter my-auto flex justify-between border-b-2 border-[#E9E8E8] pb-5">
          <div className="flex flex-col justify-start space-y-1">
            <div className="h-4 w-20 animate-pulse !rounded-sm bg-gray-200" />
            <div className="h-4 w-24 animate-pulse !rounded-sm bg-gray-200" />
            <div className="h-4 w-24 animate-pulse !rounded-sm bg-gray-200" />
          </div>
          <div className="flex flex-col justify-end space-y-1">
            <div className="h-4 w-20 animate-pulse !rounded-sm bg-gray-200" />
            <div className="mb-2 h-4 w-full animate-pulse !rounded-sm bg-gray-200" />
            <div className="h-4 w-24 animate-pulse !rounded-sm bg-gray-200" />
          </div>
        </div>

        {/* Footer section */}
        <div className="inter mt-auto flex items-center justify-between">
          <div className="h-4 w-20 animate-pulse !rounded-sm bg-gray-200" />
          <div className="h-4 w-28 animate-pulse !rounded-sm bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default CarsCardSkeleton;
